import { useEffect, useRef } from 'react';

export const useScrollReveal = () => {
  const ref = useRef(null);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    const elements = container.querySelectorAll('.reveal, .reveal-image');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }); // Intentionally no deps — re-runs on every render to catch new DOM elements after content loads
  // The observer self-cleans via disconnect in the cleanup

  return ref;
};
